import { render } from "./Edit-gift-card.vue?vue&type=template&id=350d2dde"
import script from "./Edit-gift-card.vue?vue&type=script&lang=js"
export * from "./Edit-gift-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__